import type { Resource } from '../../';
export const general_errors_headlineMessage: Resource = {"default":"We're Sorry..."};
